__turbopack_context__.v({
  "bodyText": "DetailsInputForm-module__flgPPW__bodyText",
  "col": "DetailsInputForm-module__flgPPW__col",
  "detailsInput": "DetailsInputForm-module__flgPPW__detailsInput",
  "footer": "DetailsInputForm-module__flgPPW__footer",
  "footerDesktop": "DetailsInputForm-module__flgPPW__footerDesktop",
  "formWrapper": "DetailsInputForm-module__flgPPW__formWrapper",
  "imageContainer": "DetailsInputForm-module__flgPPW__imageContainer",
  "input": "DetailsInputForm-module__flgPPW__input",
  "inputFormTitle": "DetailsInputForm-module__flgPPW__inputFormTitle",
  "labels": "DetailsInputForm-module__flgPPW__labels",
  "mileageInput": "DetailsInputForm-module__flgPPW__mileageInput",
  "mileageInputControl": "DetailsInputForm-module__flgPPW__mileageInputControl",
  "mileageStepperWrapper": "DetailsInputForm-module__flgPPW__mileageStepperWrapper",
  "notYourCar": "DetailsInputForm-module__flgPPW__notYourCar",
  "notYourCarTablet": "DetailsInputForm-module__flgPPW__notYourCarTablet",
  "pageLoader": "DetailsInputForm-module__flgPPW__pageLoader",
  "row": "DetailsInputForm-module__flgPPW__row",
  "valuationCTA": "DetailsInputForm-module__flgPPW__valuationCTA",
  "valuationCtasContainer": "DetailsInputForm-module__flgPPW__valuationCtasContainer",
  "valuationFigure": "DetailsInputForm-module__flgPPW__valuationFigure",
  "valuationTitle": "DetailsInputForm-module__flgPPW__valuationTitle",
  "valuationValue": "DetailsInputForm-module__flgPPW__valuationValue",
  "valuationWrapper": "DetailsInputForm-module__flgPPW__valuationWrapper",
  "variant": "DetailsInputForm-module__flgPPW__variant",
  "vehicleCard": "DetailsInputForm-module__flgPPW__vehicleCard",
  "vehicleCardInformation": "DetailsInputForm-module__flgPPW__vehicleCardInformation",
});
